import { cloneElement, forwardRef, useImperativeHandle } from 'react';
import useLazy from '@/hooks/useLazy';
import dynamic from 'next/dynamic';

const DynamicChangeZipCode = dynamic(() => import('./change-zipcode'), { ssr: false });

const ChangeZipCode = forwardRef((props: any, ref) => {
  const { show, hide, visible, loaded } = useLazy();
  let { children, ...rest } = props;

  useImperativeHandle(ref, () => {
    return {
      show,
      hide
    };
  });

  const handleClick = () => {
    if (!!props?.onBeforeShow) {
      return props?.onBeforeShow(show);
    }
    show?.();
  };

  return (
    <>
      {!!children &&
        cloneElement(children, {
          onClick: handleClick
        })}
      {loaded && <DynamicChangeZipCode {...rest} visible={visible} onCancel={hide} />}
    </>
  );
});

export default ChangeZipCode;
